const entries = [
  {
    icon: "ri-notification-3-line",
    title: "每日时间线推送",
    desc: "每天早 8 点，把昨日新增的事件节点整理成一条可读的摘要。",
    action: "开启推送",
  },
  {
    icon: "ri-download-2-line",
    title: "资料包下载",
    desc: "时间线对照表、文本比对稿与热度数据，打包一次性带走。",
    action: "前往下载",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "收藏本期封面",
    desc: "把整期深挖内容保存到阅读列表，断网也能继续看。",
    action: "收藏本站",
  },
];

export default function EntryBand() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=editorial%20abstract%20background%20of%20layered%20cream%20paper%20sheets%20with%20soft%20amber%20light%20streaks%20and%20muted%20vermillion%20edges%2C%20grainy%20film%20texture%2C%20wide%20cinematic%20composition%2C%20lots%20of%20empty%20space%20on%20the%20left&width=1800&height=760&seq=hh-entry-band&orientation=landscape"
        alt="热点黑料阅读入口"
        title="热点黑料 阅读入口与资料下载"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/30" />

      <div className="relative z-10 max-w-[1360px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-4">
            <span className="text-[11px] font-label tracking-[0.24em] text-accent-300">KEEP READING</span>
            <h2 className="mt-3 font-heading text-3xl md:text-[2.4rem] font-black leading-tight text-white">
              别只看到一半的事件
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-white/75">
              把入口留下，下次事件更新时你能第一时间看到完整时间线，而不是被截取的片段牵着走。
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {entries.map((entry) => (
              <div
                key={entry.title}
                className="flex flex-col rounded-lg border border-white/15 bg-white/10 backdrop-blur-sm p-5 hover:bg-white/15 transition-colors"
              >
                <span className="flex items-center justify-center w-10 h-10 rounded-md bg-accent-500 text-accent-950">
                  <i className={`${entry.icon} text-xl`} />
                </span>
                <h3 className="mt-3.5 font-heading text-base font-bold text-white">{entry.title}</h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-white/70">{entry.desc}</p>
                <button
                  type="button"
                  className="mt-4 inline-flex items-center gap-1.5 text-[12px] font-label text-accent-300 hover:text-accent-200 transition-colors whitespace-nowrap cursor-pointer w-fit"
                >
                  {entry.action}
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}